module.exports = __webpack_public_path__ + "img/IMG_2119.f041ecf9.jpg";